module.exports = __webpack_public_path__ + "static/media/s12.04711610.png";